import { Button } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import type DocumentFolder from 'stores/DocumentFolder';

import { type DocumentFolderClassRef } from './AddDocument.types';
import AddDocumentModal from './AddDocumentModal';

export interface AddDocumentButtonProps {
  parentDocument: DocumentFolder;
  documentType: DocumentFolderClassRef;
  documentTypeName: string;
}

function AddDocumentButton({
  parentDocument,
  documentType,
  documentTypeName,
}: AddDocumentButtonProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        disabled={!parentDocument.canEdit}
        onClick={() => setIsModalVisible(true)}
      >
        Add {documentTypeName}
      </Button>

      {parentDocument.canEdit && (
        <AddDocumentModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          parentDocument={parentDocument}
          documentType={documentType}
          documentTypeName={documentTypeName}
        />
      )}
    </>
  );
}

export default observer(AddDocumentButton);
